<template>
  <h1 class="text-white text-center font-bold p-4 border-b">
    نظرات تالار<span class="text-yellow-500 font-bold">
      (تعداد : {{ pagination.totalRecords }})
    </span>
  </h1>
  <div class="p-4">
    <SuggestCard
      v-for="sugg in suggest"
      :key="sugg.surveY_ID"
      :suggest="sugg"
    />

    <v-pagination
      v-model="pagination.pageNumber"
      :pages="pagination.totalPages"
      :range-size="1"
      active-color="#fcd34d"
      @update:modelValue="getSuggest"
    />
  </div>
</template>
<script>
import { getSuggest } from "../../API/API";
import VPagination from "@hennge/vue3-pagination";
import "@/assets/css/pagination.css";
import SuggestCard from "../../components/SuggestCard.vue";

export default {
  name: "ReportSuggest",
  components: { VPagination, SuggestCard },
  data() {
    return {
      showDetail: false,
      pagination: {},
      suggest: [],
      commnet: "",
    };
  },
  async created() {
    this.getSuggest(1);
  },
  methods: {
    async getSuggest(pageNumber) {
      let resp = (await getSuggest(pageNumber)).data.result;
      this.suggest = resp.item1;
      this.pagination = resp.item2;
      console.log(this.suggest);
    },
  },
};
</script>
<style scoped>
.collapse {
  max-height: 100px;
  transition: all 1s ease-out;
  overflow: hidden;
}

.expand {
  max-height: 1000px;
  transition: all 1s ease-in;
}
.textSuggest {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
}
</style>
